/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Interest_CurrenciesInputs */

const en_onboarding_v1_interest_currencies = /** @type {(inputs: Onboarding_V1_Interest_CurrenciesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currencies / FX`)
};

const de_onboarding_v1_interest_currencies = /** @type {(inputs: Onboarding_V1_Interest_CurrenciesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Währungen / Devisen`)
};

const pt_br2_onboarding_v1_interest_currencies = /** @type {(inputs: Onboarding_V1_Interest_CurrenciesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moedas / FX`)
};

const tr_onboarding_v1_interest_currencies = /** @type {(inputs: Onboarding_V1_Interest_CurrenciesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para birimleri / FX`)
};

const zh_cn2_onboarding_v1_interest_currencies = /** @type {(inputs: Onboarding_V1_Interest_CurrenciesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`货币 / 外汇`)
};

const zh_hk2_onboarding_v1_interest_currencies = /** @type {(inputs: Onboarding_V1_Interest_CurrenciesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貨幣 / 外匯`)
};

const ko_kr2_onboarding_v1_interest_currencies = /** @type {(inputs: Onboarding_V1_Interest_CurrenciesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`통화 / 외환`)
};

const ru_ru2_onboarding_v1_interest_currencies = /** @type {(inputs: Onboarding_V1_Interest_CurrenciesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Валюты / Forex`)
};

const es_419_onboarding_v1_interest_currencies = /** @type {(inputs: Onboarding_V1_Interest_CurrenciesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisas / FX`)
};

/**
* | output |
* | --- |
* | "Currencies / FX" |
*
* @param {Onboarding_V1_Interest_CurrenciesInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interest_currencies = /** @type {((inputs?: Onboarding_V1_Interest_CurrenciesInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interest_CurrenciesInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interest_currencies(inputs)
	if (locale === "de") return de_onboarding_v1_interest_currencies(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interest_currencies(inputs)
	if (locale === "tr") return tr_onboarding_v1_interest_currencies(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interest_currencies(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interest_currencies(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interest_currencies(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interest_currencies(inputs)
	return es_419_onboarding_v1_interest_currencies(inputs)
});